import { ReactComponent as AccountBehalf } from '../../icons/system/account-behalf.svg';
import { ReactComponent as Account } from '../../icons/system/account.svg';
import { ReactComponent as Add } from '../../icons/system/add.svg';
import { ReactComponent as ArrowDown } from '../../icons/system/arrow-down.svg';
import { ReactComponent as ArrowLeft } from '../../icons/system/arrow-left.svg';
import { ReactComponent as ArrowNavUp } from '../../icons/system/arrow-nav-up.svg';
import { ReactComponent as ArrowRight } from '../../icons/system/arrow-right.svg';
import { ReactComponent as ArrowUp } from '../../icons/system/arrow-up.svg';
import { ReactComponent as Cancel } from '../../icons/system/cancel.svg';
import { ReactComponent as CheckFilled } from '../../icons/system/check-filled.svg';
import { ReactComponent as Checkmark } from '../../icons/system/checkmark.svg';
import { ReactComponent as Close } from '../../icons/system/close.svg';
import { ReactComponent as Delete } from '../../icons/system/delete.svg';
import { ReactComponent as Edit } from '../../icons/system/edit.svg';
import { ReactComponent as Error } from '../../icons/system/error.svg';
import { ReactComponent as FileAdd } from '../../icons/system/file-add.svg';
import { ReactComponent as File } from '../../icons/system/file.svg';
import { ReactComponent as Files } from '../../icons/system/files.svg';
import { ReactComponent as Filter } from '../../icons/system/filter.svg';
import { ReactComponent as InfoCircle } from '../../icons/system/info-circle.svg';
import { ReactComponent as ExternalLink } from '../../icons/system/link-external.svg';
import { ReactComponent as Location } from '../../icons/system/location.svg';
import { ReactComponent as Menu } from '../../icons/system/menu.svg';
import { ReactComponent as None } from '../../icons/system/none.svg';
import { ReactComponent as SignIn } from '../../icons/system/sign-in.svg';
import { ReactComponent as SignOut } from '../../icons/system/sign-out.svg';

export const systemIcons = {
  Account,
  AccountBehalf,
  Add,
  ArrowDown,
  ArrowLeft,
  ArrowNavUp,
  ArrowRight,
  ArrowUp,
  Cancel,
  CheckFilled,
  Checkmark,
  Close,
  Delete,
  Edit,
  Error,
  ExternalLink,
  File,
  Files,
  FileAdd,
  InfoCircle,
  Location,
  Menu,
  SignIn,
  SignOut,
  None,
  Filter,
};
